import { Pipe, PipeTransform } from '@angular/core';
import { TransactionResultStatus } from '~core/models/payment.models';
import { StickerMovementStatus } from '~core/models/sticker.models';

@Pipe({
  name: 'transactionStatus',
  pure: true,
  standalone: true
})
export class TransactionStatusPipe implements PipeTransform {
  private readonly _typeMap: Record<StickerMovementStatus['status'], string> = {
    accepted: 'Accepté',
    refused: 'Refusé',
    pending: 'En attente',
    completed: 'Terminé',
    canceled: 'Expiré',
    failed: 'Echoué',
    reversed: 'Reversé',
    processing: 'En cours',
    unknown: 'Inconnu',
    expired: 'Expiré'
  };

  transform(type: TransactionResultStatus): string {
    return this._typeMap[type] || type;
  }
}
